import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";
import { setupListeners } from "@reduxjs/toolkit/query";

// === Slices ===
import { apiSlice } from "./slices/apiSlice";
import authReducer from "./slices/authSlice";
import { competitorSlice } from "./slices/competitorSlice";
import panelSlice from "./slices/panelSlice";
import projectSlice from "./slices/projectSlice";

// === Encryption config for redux-persist ===
const encryptor = encryptTransform({
  secretKey: process.env.REACT_APP_SECRET_KEY,
  onError: (error) => console.error("Encryption error:", error),
});

// === Persist config (for auth slice only) ===
const authPersistConfig = {
  key: "auth",
  storage,
  transforms: [encryptor],
  whitelist: ["userInfo", "accessToken", "isStreaming"], // only persist these fields
};

// === Persisted reducer ===
const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);

// === Configure store ===
const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: persistedAuthReducer,
    panelSlice,
    competitorAnalysis: competitorSlice.reducer,
    project: projectSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/FLUSH",
          "persist/PAUSE",
          "persist/PURGE",
          "persist/REGISTER",
        ],
        ignoredPaths: ["panelSlice.currentZone"], // if needed
      },
    }).concat(apiSlice.middleware),
  devTools: process.env.NODE_ENV !== "production", // safer devTools check
});

// === Persistor ===
const persistor = persistStore(store);

// === RTK Query listeners for refetchOnFocus/refetchOnReconnect ===
setupListeners(store.dispatch);

// === Exports ===
export { store, persistor };
export const { dispatch, getState } = store;
